import get from 'lodash/get';
import { func, oneOfType, string } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { errorShape } from '../../prop-types';
import ValidationErrors from '../ValidationErrors';

function ErrorComponent({ error, component: Component, ...rest }) {
  const detail = get(error, ['data', 'detail']);
  const validationErrors = !detail && get(error, ['data']);
  const immediateResponseError =
    typeof validationErrors === 'string' && validationErrors;
  return (
    <Component color="danger" {...rest}>
      {error.message}
      {immediateResponseError && ` (${immediateResponseError})`}
      {detail && <div>{detail}</div>}
      {validationErrors && typeof validationErrors === 'object' && (
        <ValidationErrors errors={validationErrors} />
      )}
    </Component>
  );
}

ErrorComponent.propTypes = {
  error: errorShape.isRequired,
  component: oneOfType([func, string]),
  className: string,
};

ErrorComponent.defaultProps = {
  component: Alert,
  className: 'white-space-pre-wrap',
};

export default ErrorComponent;
